import * as React from "react";
import {BookingRequestCard} from "./BookingRequestCard";
import {BookingInfo} from "../../../../js/api/bookings/BookingInfo";
import {GetAllUnapprovedBookings} from "../../../../js/api/bookings/GetBookings";
import {ApproveBooking, DeclineBooking} from "../../../../js/api/bookings/UpdateBookingStatus";
import {Loadable} from "../../../../js/pages/Loadable";

interface State {
    loading: boolean;
    requests: BookingInfo[];
}

interface Props {
    token: object;
}

class BookingRequests extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: true,
            requests: []
        };
    }

    componentDidMount() {
        this.FetchUnapprovedBookings();
    }

    private FetchUnapprovedBookings = () => {
        this.setState({loading: true});
        GetAllUnapprovedBookings(this.props.token)
            .then(result => this.setState({requests: result, loading: false}))
    };

    private onApprove = async (bookingId: number, sendEmail: boolean) => {
        await ApproveBooking(bookingId, sendEmail, this.props.token);
        this.FetchUnapprovedBookings()
    };

    private onDecline = async (bookingId: number, sendEmail: boolean) => {
        await DeclineBooking(bookingId, sendEmail, this.props.token);
        this.FetchUnapprovedBookings()
    };

    render() {
        return (
            <div>
                <h1>Booking Requests</h1>
                <Loadable loading={this.state.loading}>
                    <div id={"BookingRequestData"}>
                        <div className={"br_scrollbox"}>
                            {
                                this.state.requests.length === 0 ?
                                    <h3>No pending requests.</h3> :
                                this.state.requests.map((r) => (
                                        <BookingRequestCard
                                            key={r.id}
                                            request={r}
                                            onAccept={this.onApprove}
                                            onReject={this.onDecline}
                                        />
                                    )
                                )
                            }
                        </div>
                    </div>
                </Loadable>
            </div>
        );
    }
}

export default BookingRequests;